// Each entry: { value — sent to API, title — displayed on screen }

export const JOB_FUNCTION_OPTIONS = [
  { value: "engineering",          title: "Engineering" },
  { value: "design",               title: "Design" },
  { value: "marketing",            title: "Marketing" },
  { value: "sales",                title: "Sales" },
  { value: "finance",              title: "Finance" },
  { value: "operations",           title: "Operations" },
  { value: "human_resources",      title: "Human Resources" },
  { value: "product_management",   title: "Product Management" },
  { value: "customer_service",     title: "Customer Service" },
  { value: "legal",                title: "Legal" },
  { value: "healthcare",           title: "Healthcare" },
  { value: "education",            title: "Education" },
  { value: "it_technology",        title: "IT / Technology" },
  { value: "research_development", title: "Research & Development" },
];

export const SENIORITY_OPTIONS = [
  { value: "intern",      title: "Intern" },
  { value: "entry_level", title: "Entry Level" },
  { value: "associate",   title: "Associate" },
  { value: "mid_level",   title: "Mid Level" },
  { value: "senior",      title: "Senior" },
  { value: "lead",        title: "Lead" },
  { value: "manager",     title: "Manager" },
  { value: "director",    title: "Director" },
  { value: "vp",          title: "VP" },
  { value: "c_level",     title: "C-Level" },
];

export const INDUSTRY_OPTIONS = [
  { value: "healthcare",          title: "Healthcare" },
  { value: "technology",          title: "Technology" },
  { value: "finance",             title: "Finance" },
  { value: "education",           title: "Education" },
  { value: "manufacturing",       title: "Manufacturing" },
  { value: "retail",              title: "Retail" },
  { value: "government",          title: "Government" },
  { value: "non_profit",          title: "Non-Profit" },
  { value: "real_estate",         title: "Real Estate" },
  { value: "media_entertainment", title: "Media & Entertainment" },
  { value: "transportation",      title: "Transportation" },
  { value: "energy",              title: "Energy" },
  { value: "construction",        title: "Construction" },
];

export const COMPANY_SIZE_OPTIONS = [
  { value: "1-10",       title: "1-10" },
  { value: "11-50",      title: "11-50" },
  { value: "51-200",     title: "51-200" },
  { value: "201-500",    title: "201-500" },
  { value: "501-1K",     title: "501-1K" },
  { value: "1K-5K",      title: "1K-5K" },
  { value: "5K-10K",     title: "5K-10K" },
  { value: "10K+",       title: "10K+" },
];

export const EXPERIENCE_OPTIONS = [
  { value: "0-2",    title: "0-2 yrs" },
  { value: "3-5",    title: "3-5 yrs" },
  { value: "6-10",   title: "6-10 yrs" },
  { value: "10-15",  title: "10-15 yrs" },
  { value: "15-20",  title: "15-20 yrs" },
  { value: "20_100", title: "20+ yrs" },
];

export const EXPERIENCE_OPTIONS_INTERNAL_MARKETPLACE = [
  { value: "Less than 1 year", title: "Less than 1 year" },
  { value: "1-2 years",        title: "1-2 yrs" },
  { value: "3-5 years",        title: "3-5 yrs" },
  { value: "6-10 years",       title: "6-10 yrs" },
  { value: "10-15",            title: "10-15 yrs" },
  { value: "15-20",            title: "15-20 yrs" },
  { value: "20_100",           title: "20+ yrs" },
];

export const LANGUAGE_OPTIONS = [
  { value: "en", title: "English" },
  { value: "es", title: "Spanish" },
  { value: "fr", title: "French" },
  { value: "de", title: "German" },
  { value: "zh", title: "Mandarin" },
  { value: "ar", title: "Arabic" },
  { value: "hi", title: "Hindi" },
  { value: "pt", title: "Portuguese" },
  { value: "ru", title: "Russian" },
  { value: "ja", title: "Japanese" },
  { value: "ko", title: "Korean" },
  { value: "it", title: "Italian" },
];

export const INITIAL = {
  name: "",
  keyword: "",
  jobTitleInclude: [],
  jobTitleExclude: [],
  currentTitlesOnly: false,
  includeRelatedTitles: false,
  // matchExperience: "",
  jobFunction: [],
  seniority: [],
  companyInclude: [],
  companyExclude: [],
  companyCurrentOnly: false,
  companyIncludeRelated: false,
  domain: "",
  industry: [],
  companySize: [],
  location: [],
  cityId: [],
  cityName: [],
  regionId: [],
  regionName: [],
  countryId: [],
  countryName: [],
  skillListingType: "",
  budgetMin: "",
  budgetMax: "",
  budgetType: "",
  visaStatusId: [],
  experienceLevel: [],
  locationRadius: null,
  currentWorkLocation: [],
  pastWorkLocation: [],
  remoteLocation: [],
  skill: [],
  yearsOfExp: [],
  yearsOfExpCurrentRole: [],
  school: [],
  language: [],
};

export const countActive = (...vals) =>
  vals.filter((v) =>
    Array.isArray(v) ? v.length > 0 : v != null && v !== ""
  ).length;

export const getLocationFilterCount = (filters = INITIAL) => {
  const hasCombinedLocation = countActive(filters.location) > 0;

  return (
    (hasCombinedLocation
      ? 1
      : countActive(filters.cityId, filters.regionId, filters.countryId)) +
    countActive(
      filters.currentWorkLocation,
      filters.pastWorkLocation,
      filters.remoteLocation
    )
  );
};

export const getVisibleLocationFilterCount = (filters = INITIAL) =>
  countActive(
    filters.cityId,
    filters.regionId,
    filters.countryId
  );

export const getSkillsExperienceFilterCount = (filters = INITIAL) => {
  const hasLegacyExperience = countActive(filters.experienceLevel) > 0;

  return (
    countActive(filters.skill) +
    (hasLegacyExperience
      ? 1
      : countActive(filters.yearsOfExp, filters.yearsOfExpCurrentRole))
  );
};

export const getVisibleSkillsExperienceFilterCount = (
  filters = INITIAL,
  { useLegacyExperience = false } = {}
) =>
  useLegacyExperience
    ? countActive(
        filters.skill,
        filters.skillListingType,
        filters.experienceLevel,
        filters.budgetMin,
        filters.budgetMax,
        filters.budgetType
      )
    : countActive(
        filters.skill,
        filters.yearsOfExp,
        filters.yearsOfExpCurrentRole
      );

export const getActiveFilterCount = (filters = INITIAL) =>
  countActive(
    filters.name,
    filters.keyword,
    // filters.matchExperience,
    filters.jobTitleInclude,
    filters.jobTitleExclude,
    filters.jobFunction,
    filters.seniority,
    filters.companyInclude,
    filters.companyExclude,
    filters.domain,
    filters.industry,
    filters.companySize,
    filters.skillListingType,
    filters.budgetMin,
    filters.budgetMax,
    filters.budgetType,
    filters.visaStatusId,
    filters.school,
    filters.language
  ) +
  getLocationFilterCount(filters) +
  getSkillsExperienceFilterCount(filters) +
  (filters.currentTitlesOnly ? 1 : 0) +
  (filters.includeRelatedTitles ? 1 : 0) +
  (filters.companyCurrentOnly ? 1 : 0) +
  (filters.companyIncludeRelated ? 1 : 0);

// ── Panel keys and titles ─────────────────────────────────────────────
export const PANELS = {
  IDENTITY:  { key: "identity",  title: "Identity & Basic Info" },
  JOB_TITLE: { key: "jobTitle",  title: "Job Title & Role" },
  COMPANY:   { key: "company",   title: "Company & Organization" },
  LOCATION:  { key: "location",  title: "Location" },
  SKILLS:    { key: "skills",    title: "Skills & Experience" },
  EDUCATION: { key: "education", title: "Education" },
  LANGUAGE:  { key: "language",  title: "Languages" },
};
